import { render, staticRenderFns } from "./DetailsBoxHeading.vue?vue&type=template&id=f7ea536e"
import script from "./DetailsBoxHeading.vue?vue&type=script&lang=ts"
export * from "./DetailsBoxHeading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports